import { Document, Image, Page, PDFDownloadLink, StyleSheet, Text, View } from "@react-pdf/renderer"
import { useSelector } from "react-redux";
import { getCardinalDirectionFromAngle } from "../services/weather.service";

const mainColor = '#000000'
const styles = StyleSheet.create({
	page: {
		backgroundColor: 'white',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start'
	},
	title: {
		fontSize: '20px',
		margin: 'auto',
		color: mainColor
	},
	section: {
		padding: 10,
		width: '80%',
		maxHeight: '10px',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	newSection: {
		marginTop: '24px'
	},
	logoSection: {
		height: '120px',
		position: 'relative',
		top: '8px',
		width: '100%',
		marginBottom: '42px'
	},
	logo: {
		width: '72px',
		height: '72px',
		margin: 'auto'
	},
	text: {
		title: {
			color: mainColor,
			fontWeight: 600,
			fontSize: '10px'
		},
		value: {
			color: mainColor,
			fontWeight: 400,
			fontSize: '12px'
		}
	},
	footer: {
		position: 'absolute',
		bottom: '0px',
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '8px'
	},
	footerLeft: {
		width: '50%'
	},
	footerRight: {
		width: '50%',
		textAlign: 'right'
	},
	footerText: {
		fontSize: '8px',
		color: mainColor,
	},
	button: {
		color: 'white'
	}
});

export const PDFReviewDocument = ({ values }) => {
	const { info, location, fuelLoad, weather, comments, closestSSA, recommendation } = values;

	return (
		<Document>
			<Page size="A4" style={styles.page}>
				<View style={styles.logoSection}>
					<Image src="/logo_black_and_white.png" style={styles.logo} />
					<Text style={styles.title}>FireSmart Burn Report</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Name:</Text>
					<Text style={styles.text.value}>{info.name}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Phone:</Text>
					<Text style={styles.text.value}>{info.phoneNum}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Start Date:</Text>
					<Text style={styles.text.value}>{new Date(info.startDate).toLocaleString()}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>End Date:</Text>
					<Text style={styles.text.value}>{new Date(info.endDate).toLocaleString()}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>County:</Text>
					<Text style={styles.text.value}>{location ? location.county : ''}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Location:</Text>
					<Text style={styles.text.value}>
						{location && location.coords ? `lat: ${location.coords.latitude.toFixed(2)}°, lng: ${location.coords.longitude.toFixed(2)}°`: ''}
					</Text>
				</View>

				<View style={[styles.section, styles.newSection]} wrap={false}>
					<Text style={styles.text.title}>Field Crop/Forestry:</Text>
					<Text style={styles.text.value}>{fuelLoad.cropType}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Fuel Loading:</Text>
					<Text style={styles.text.value}>{fuelLoad.fuelLoadingRange ? ['Low', 'Medium', 'Heavy'][fuelLoad.fuelLoadingRange] : ''}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Total Acres:</Text>
					<Text style={styles.text.value}>{fuelLoad.totalAcres}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Total Tonnage:</Text>
					<Text style={styles.text.value}>{fuelLoad.totalTonnage.toFixed(2)}</Text>
				</View>

				<View style={[styles.section,styles.newSection]} wrap={false}>
					<Text style={styles.text.title}>Nearest SSA:</Text>
					<Text style={styles.text.value}>
						{closestSSA ?
							<span>
								{closestSSA.name} - {closestSSA.type} <br />
								{closestSSA.address}
							</span>
							: ''
						}
					</Text>
				</View>
				
				<View style={[styles.section, styles.newSection]} wrap={false}>
					<Text style={styles.text.title}>Additional Information:</Text>
					<Text style={styles.text.value}>{comments}</Text>
				</View>

				<View style={[styles.section, styles.newSection]} wrap={false}>
					<Text style={styles.text.title}>Category Day:</Text>
					<Text style={styles.text.value}>{weather.catDay}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Wind Direction:</Text>
					<Text style={styles.text.value}>{weather.windDirection && weather.windDirection.value ? '' +weather.windDirection.value+'°' +' ' + getCardinalDirectionFromAngle(weather.windDirection.value):'null'}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Wind Speed:</Text>
					<Text style={styles.text.value}>{weather.windSpeed && weather.windSpeed.value ? weather.windSpeed.value + ' mph': 'null'}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Humidity:</Text>
					<Text style={styles.text.value}>{weather.humidity && weather.humidity.value? weather.humidity.value + '%' : 'null'}</Text>
				</View>
				
				<View style={[styles.section, styles.newSection]} wrap={false}>
					<Text style={styles.text.title}>Total Tonnage of this Burn:</Text>
					<Text style={styles.text.value}>{recommendation.totalTonnageForThisBurn.toFixed(1)}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Total Tonnage within Airshed:</Text>
					<Text style={styles.text.value}>{recommendation.totalTonnageForAllBurns.toFixed(1)}</Text>
				</View>
				{/* <View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Total Allowed Tonnage of this Burn:</Text>
					<Text style={styles.text.value}>{recommendation.allocatedTonnage.toFixed(1)}</Text>
				</View>
				<View style={styles.section} wrap={false}>
					<Text style={styles.text.title}>Recommended Max. Burn Acreage:</Text>
					<Text style={styles.text.value}>{recommendation.totalAllowedAcres.toFixed(1)}</Text>
				</View> */}

				{(recommendation && recommendation.deniedReason && recommendation.deniedReason.tonsExceeded) ?
				<View style={[styles.section,{marginTop: '42px'}]} wrap={true}>
					<Text style={styles.text.value}>
						The fuel tonnage of this burn will result in an 
						<b> exceedance of the voluntary smoke management guidelines</b> total tonnage within this airshed. 
						Please consider revising your burn plan and changing this submittal. 
						Please contact the ADA dispatch center (1-800-830-8015) if you have any questions.
					</Text>
				</View>
				:
				<View style={[styles.section,{marginTop: '42px'}]} wrap={true}>
					<Text style={styles.text.value}>
						This burn is consistent with the voluntary smoke management guidelines. 
						Please contact the ADA dispatch center (1-800-830-8015) if you have any questions.
					</Text>
				</View>
				}


				<View style={styles.footer} wrap={false}>
					<View style={styles.footerLeft}>
						<Text style={styles.footerText}></Text>
					</View>
					<View style={styles.footerRight}>
						<Text style={styles.footerText}>{new Date().toLocaleDateString()}</Text>
					</View>
				</View>
			</Page>
		</Document>
	)
}

export const PDFReviewDownloadButton = ({ fileName, onClick }) => {
	const onPdfDownload = ({ blob, url, loading, error }) => loading ? 'Generating PDF document...' : 'Submission PDF Link'
	const values = useSelector(state => state.submission);

	return (
		<PDFDownloadLink 
		onClick={onClick}
		document={<PDFReviewDocument values={values} />}
		fileName={fileName}
		style={styles.button}>
			{onPdfDownload}
		</PDFDownloadLink>
	)
}